var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7805 1.42682C15.0199 1.66628 15.1925 1.96429 15.281 2.29118C15.7903 4.34141 15.6726 7.57943 15.2908 9.70876C15.2024 10.0357 15.0298 10.3337 14.7904 10.5731C14.5509 10.8126 14.2529 10.9851 13.926 11.0736C12.7293 11.4 7.91282 11.4 7.91282 11.4C7.91282 11.4 3.09634 11.4 1.89964 11.0736C1.57275 10.9851 1.27473 10.8126 1.03527 10.5731C0.79581 10.3337 0.623259 10.0357 0.534803 9.70876C0.0224953 7.66745 0.162935 4.42745 0.524914 2.30108C0.613369 1.97418 0.785919 1.67616 1.02538 1.43671C1.26484 1.19725 1.56286 1.02469 1.88975 0.936242C3.08645 0.609863 7.90293 0.599976 7.90293 0.599976C7.90293 0.599976 12.7194 0.599976 13.9161 0.926348C14.243 1.01481 14.541 1.18736 14.7805 1.42682ZM10.3656 5.99997L6.36997 8.31426V3.68569L10.3656 5.99997Z",
    fill: "#313945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMin);
export default __webpack_public_path__ + "static/media/youtubeMin.9e2323371a70e64d52ff19076a1540a4.svg";
export { ForwardRef as ReactComponent };